export default __webpack_public_path__ + "static/media/Triangles_04.0e3558df.png";